export const BUSINESS_HOURS = {
  start: 9, // 9 AM
  end: 18, // 6 PM
  weekdays: [1, 2, 3, 4, 5], // Monday-Friday
};

/**
 * Checks if the current time is within business hours
 * Business hours: 9 AM - 6 PM, Monday-Friday (user's local timezone)
 * @returns true if within business hours, false otherwise
 */
export function isWithinBusinessHours(): boolean {
  const now = new Date();
  const hour = now.getHours();
  const day = now.getDay();

  const isWeekday = BUSINESS_HOURS.weekdays.includes(day);
  const isDuringHours =
    hour >= BUSINESS_HOURS.start && hour < BUSINESS_HOURS.end;

  return isWeekday && isDuringHours;
}
